import React, { useCallback, useState } from 'react';
import { useTranslate } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { showNotification } from 'react-admin';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import { CircularProgress, DialogContentText, TextField } from '@material-ui/core';
import axios from 'axios';
import { deleteFileSystemNode } from '../../../../../services/file-explorer/fileExplorerApi';
import { useQueryClient } from 'react-query';

const useStyles = makeStyles(
{
    fullWidth: {
        width: '100%',
    },
});

function DeleteFileSystemNodeDialog(props) {
    const { open, fileSystemNodePath, handleCancel, showNotification } = props;

    const translate = useTranslate();
    const queryClient = useQueryClient();

    const [isLoading, setIsLoading] = useState(false);
    
    const startDeleteFileSystemNode = useCallback(() => {
        if (isLoading) {
            return;
        }
        setIsLoading(true);
        const cancellationTokenSource = axios.CancelToken.source();
        deleteFileSystemNode(fileSystemNodePath, cancellationTokenSource.token)
        .then((response) => {
            handleCancelInternal();
            queryClient.invalidateQueries(['/file-explorer/search', 'getDirectoryContent']);
            setIsLoading(false);
            showNotification(`cmss.resources.file-explorer.directory-actions-menu.delete-file-system-node.deletion-successful`, 'success');
        }).catch((error) => {
            showNotification(`cmss.resources.file-explorer.directory-actions-menu.delete-file-system-node.deletion-unsuccessful`, 'warning');
            setIsLoading(false);
            if (axios.isCancel(error)) {
                return;
            }
        });
    
        return () => {
            cancellationTokenSource.cancel();
        }
    }, [isLoading, fileSystemNodePath, queryClient]);


    function resetDialog() {
        setIsLoading(false);
    }

    function handleOnClickDeleteDialogButton() {
        startDeleteFileSystemNode();
    }

    function handleCancelInternal() {
        handleCancel();
    }

    const name = fileSystemNodePath.length > 0 ? fileSystemNodePath[fileSystemNodePath.length - 1] : '';
    return (
        <Dialog open={open} TransitionProps={{onEnter: resetDialog, onClose: handleCancelInternal}} fullWidth={true} maxWidth="sm">
            <DialogTitle>{translate(`cmss.resources.file-explorer.directory-actions-menu.buttons.delete`)} <small>({name})</small></DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {translate(`cmss.resources.file-explorer.directory-actions-menu.delete-file-system-node.are-you-sure-you-want-to-delete`)}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={handleCancelInternal} color="primary">
                    {translate(`cmss.resources.file-explorer.directory-actions-menu.delete-file-system-node.cancel`)}
                </Button>
                <Button
                    disabled={isLoading}
                    onClick={handleOnClickDeleteDialogButton}
                    color="secondary"
                    >
                        {translate(`cmss.resources.file-explorer.directory-actions-menu.delete-file-system-node.delete`)}
                        {isLoading && (
                            <CircularProgress
                                size={24}
                                style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    marginTop: '-12px',
                                    marginLeft: '-12px',
                                }}
                            />
                        )}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default connect(null, {
    showNotification
})(DeleteFileSystemNodeDialog);